import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Stream from 'flarum/common/utils/Stream';

export default class CalendarSyncModal extends Modal {

  oninit(vnode) {
    super.oninit(vnode);

    this.token = Stream(null);
    this.loading = Stream(true);
    this.copied = Stream(false);

    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/events/ical-token',
    }).then((data) => {
      this.token(data.token);
      this.loading(false);
      m.redraw();
    }).catch(() => {
      this.loading(false);
      m.redraw();
    });
  }

  className() {
    return 'Modal--medium CalendarSyncModal';
  }

  title() {
    return app.translator.trans(
      'florcarioca-rsvp.forum.calendar.title'
    );
  }

  content() {
    const t = (k) =>
      app.translator.trans(
        'florcarioca-rsvp.forum.calendar.' + k
      );

    if (this.loading()) {
      return (
        <div className="Modal-body">
          <LoadingIndicator />
        </div>
      );
    }

    if (!this.token()) {
      return (
        <div className="Modal-body">
          <p className="helpText">
            {t('error')}
          </p>
        </div>
      );
    }

    const apiUrl = app.forum.attribute('apiUrl');
    const icsUrl = apiUrl + '/events/ical?token=' + this.token();
    const webcalUrl = icsUrl.replace(/^https?:\/\//, 'webcal://');
    const downloadUrl = icsUrl + '&download=1';
    const googleUrl = 'https://calendar.google.com/calendar/u/0/r/settings/addbyurl';

    return (
      <div className="Modal-body CalendarSyncModal-body">

        <p className="helpText">
          {t('description')}
        </p>

        <div className="Form-group">

          <label>
            {t('url_label')}
          </label>

          <div className="CalendarSyncModal-urlRow">

            <input
              className="FormControl"
              type="text"
              readonly
              value={webcalUrl}
              onclick={(e) => e.target.select()}
            />

            <Button
              className="Button"
              icon={
                this.copied()
                  ? 'fas fa-check'
                  : 'fas fa-copy'
              }
              onclick={() => {
                navigator.clipboard
                  .writeText(webcalUrl)
                  .then(() => {
                    this.copied(true);
                    m.redraw();

                    setTimeout(() => {
                      this.copied(false);
                      m.redraw();
                    }, 2000);
                  });
              }}
            >
              {
                this.copied()
                  ? t('copied')
                  : t('copy')
              }
            </Button>

          </div>

        </div>

        <div className="CalendarSyncModal-actions">

          {/* Abonnement direct via WebCal */}
          <a
            href={webcalUrl}
            className="Button Button--primary"
          >
            <i className="fas fa-calendar-plus Button-icon" />

            <span className="Button-label">
              {t('subscribe')}
            </span>
          </a>

          {/* Google Calendar */}
          <a
            href={googleUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="Button"
          >
            <i className="fab fa-google Button-icon" />

            <span className="Button-label">
              {t('google')}
            </span>
          </a>

          {/* Téléchargement ICS */}
          <a
            href={downloadUrl}
            className="Button"
          >
            <i className="fas fa-download Button-icon" />

            <span className="Button-label">
              {t('download')}
            </span>
          </a>

        </div>

        <p className="helpText CalendarSyncModal-googleHelper">
          <strong>
            {t('google')} :{' '}
          </strong>
          {t('google_helper')}
        </p>

        <p className="helpText CalendarSyncModal-syncDelay">
          {t('sync_delay')}
        </p>

        <p className="helpText CalendarSyncModal-note">
          {t('note')}
        </p>

      </div>
    );
  }

}
